<template>
  <div class="member-experts">
    <!-- Regular experts -->
    <div class="experts-section" v-if="regularExperts.length > 0">
      <div class="experts-title">
        Специалисты по организации строительства, предусмотренные в соответствии
        с п. 2 ч. 6 ст. 55.5 ГрК РФ: {{ regularExperts.length }}
      </div>
      <table class="experts-table">
        <thead>
          <tr>
            <th>Идентификационный номер в НРС</th>
            <th>ФИО</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="expert in regularExperts" :key="expert.id" :class="{ 'highlighted-expert': expert.is_highlighted }">
            <td>
              <!-- <a :href="getNrsLink(expert.number)" target="_blank">{{ expert.number }}</a> -->
              {{ expert.number }}
            </td>
            <td>{{ expert.fio }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Danger experts -->
    <div class="experts-section" v-if="dangerExperts.length > 0">
      <div class="experts-title">
        Работники указанные в минимальных требованиях к членам СРО, выполняющим
        строительство, реконструкцию, капитальный ремонт, снос особо опасных,
        технически сложных и уникальных объектов, объектов использования атомной
        энергии, указанных в подпунктах "а" и "б" п. 1 ч. 1 ст. 48.1 ГрК РФ:
        {{ dangerExperts.length }}
      </div>
      <table
        class="experts-table"
        v-for="(group, index) in dangerExpertsGrouped"
        :key="index"
      >
        <thead>
          <tr>
            <th v-if="group.showNumber">{{ group.title }}</th>
            <th :style="!group.showNumber ? 'width: 100%' : ''">ФИО</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="expert in group.experts" :key="expert.id" :class="{ 'highlighted-expert': expert.is_highlighted }">
            <td v-if="group.showNumber">
              {{ expert.number }}
            </td>
            <td :style="!group.showNumber ? 'width: 100%' : ''">{{ expert.fio }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Other experts -->
    <div class="experts-section" v-if="otherExperts.length > 0">
      <div class="experts-title">
        Иные специалисты в области строительства, реконструкции, капитального
        ремонта, сноса объектов капитального строительства, предусмотренные в
        соответствии с ч. 2 ст. 55.20-1 ГрК РФ:
        <span> {{ otherExperts.length }}</span>
      </div>
      <table class="experts-table">
        <thead>
          <tr>
            <th>Номер</th>
            <th>ФИО</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="expert in otherExperts" :key="expert.id" :class="{ 'highlighted-expert': expert.is_highlighted }">
            <td>
              {{ expert.number }}
            </td>
            <td>{{ expert.fio }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="!hasExperts" class="no-data">Нет данных о специалистах</div>

    <!-- Footer dates -->
    <div class="dates-footer">
      <div class="date-row">
        <div class="date-label">Дата создания:</div>
        <div class="date-value">
          {{
            getTimeFromDateTimeString(registryRegistrationDateTimeString) || '-'
          }}
        </div>
      </div>
      <div class="date-row">
        <div class="date-label">Обновлено:</div>
        <div class="date-value">
          {{
            lastUpdatedExpertsAtDateTimeString
              ? getTimeFromDateTimeString(lastUpdatedExpertsAtDateTimeString)
              : '-'
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { OPEN_NRS_URI } from '../../helpers/constants'
import { getTimeFromDateTimeString } from '../../helpers/helper'

export default {
  name: 'MemberExperts',
  props: {
    expertsByCategory: {
      type: Object,
      default: () => ({})
    },
    registryRegistrationDateTimeString: {
      type: String,
      default: ''
    },
    lastUpdatedExpertsAtDateTimeString: {
      type: String,
      default: ''
    }
  },
  computed: {
    regularExperts() {
      return this.expertsByCategory?.regular || []
    },
    dangerExperts() {
      return this.expertsByCategory?.danger || []
    },
    otherExperts() {
      return this.expertsByCategory?.other || []
    },
    dangerExpertsGrouped() {
      const groupsMap = {
        nrs: { title: 'Идентификационный номер в НРС', showNumber: true, experts: [] },
        other: { showNumber: false, experts: [] }
      }

      this.dangerExperts.forEach((expert) => {
        if (this.isNrsNumber(expert.number)) {
          groupsMap.nrs.experts.push(expert)
        } else {
          groupsMap.other.experts.push(expert)
        }
      })

      return Object.values(groupsMap).filter(group => group.experts.length > 0)
    },
    hasExperts() {
      return (
        this.regularExperts.length > 0 ||
        this.dangerExperts.length > 0 ||
        this.otherExperts.length > 0
      )
    }
  },
  methods: {
    getNrsLink(number) {
      return `${OPEN_NRS_URI}/specialist/${number}`
    },
    isNrsNumber(number) {
      return /^[СCПPИI]-(?:\d{2,3}|[А-ЯA-Z]{2})-\d{6}$/i.test(number)
    },
    getTime(string) {
      return string.split(' ')[0]
    },
    getTimeFromDateTimeString
  }
}
</script>

<style scoped>
.member-experts {
  padding: 20px;
}

.experts-section {
  margin-bottom: 30px;
}

.experts-title {
  text-align: center;
  margin-bottom: 15px;
  font-size: 17px;
  line-height: 1.5;
  font-weight: 700;
}

.experts-table {
  width: 70%;
  border-collapse: collapse;
  margin-bottom: 10px;
  margin-left: auto;
  margin-right: auto;
}

.experts-table th,
.experts-table td {
  padding: 12px 15px;
  text-align: center;
  border-bottom: 1px solid #e0e0e0;
}

.experts-table th:first-child,
.experts-table td:first-child {
  width: 50%;
}

.experts-table th:last-child,
.experts-table td:last-child {
  width: 50%;
}

.experts-table th {
  color: rgba(0, 0, 0, 0.54);
  font-weight: 500;
}

.experts-table td a {
  color: #1976d2;
  text-decoration: none;
}

.experts-table td a:hover {
  text-decoration: underline;
}

.experts-table tr.highlighted-expert td,
.experts-table tr.highlighted-expert td a {
  color: #d32f2f; /* Бледно-красный цвет текста */
}

.experts-table tr.highlighted-expert td {
  background-color: #fff0f0; /* Светлая красноватая подложка */
  border-top: 1px solid #ffcdd2 !important; /* Тонкая рамка сверху */
  border-bottom: 1px solid #ffcdd2 !important; /* Тонкая рамка снизу */
}

.experts-table tr.highlighted-expert td:first-child {
  border-left: 1px solid #ffcdd2 !important; /* Тонкая рамка слева */
}

.experts-table tr.highlighted-expert td:last-child {
  border-right: 1px solid #ffcdd2 !important; /* Тонкая рамка справа */
}

.no-data {
  text-align: center;
  padding: 24px;
}

.dates-footer {
  margin-top: 30px;
  text-align: center;
  padding-top: 20px;
}

.date-row {
  margin-bottom: 15px;
}

.date-label {
  font-weight: 700;
  margin-bottom: 5px;
}
</style>
